import { __ } from '@wordpress/i18n';
import { VayuBlocksBackground, VayuBlocksAlignment,VayuBlocksTypography,
    VayuBlocksDimensions, HeightControl, VayuBlocksBorder} from '@vayu-blocks';
import { PanelBody} from '@wordpress/components';

const Style = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

    return (
        <>
            <PanelBody
                title={__('Title', 'vayu-blocks')}
                opened={openPanels['toc-style']}
                onToggle={() => onTogglePanel('toc-style')}
            >

                <VayuBlocksAlignment
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    alignment = {{key:'iconalignment',value:attributes.iconalignment}}
                    options = {{spaceBetween:__('space-between', 'vayu-blocks')}}
                />

                <VayuBlocksBackground
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    colorPanel = {[
                        {
                            active: ['gradient'],
                            label: 'Background',
                            key:'titlebg',
                            value:attributes.titlebg,
                        },
                        {
                            active: ['color'],
                            label: 'Color',
                            key:'titlecolor',
                            value:attributes.titlecolor,
                        },
                    ]}
                />

                <VayuBlocksDimensions
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    dimensions={{ padding: { key: 'titlePadding', value: attributes.titlePadding }}}
                />

                <br/>

                <VayuBlocksBorder
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    border={{ key: 'titleBorder', value: attributes.titleBorder }}
                    borderRadius={{ key: 'titleBorderRadius', value: attributes.titleBorderRadius }}
                />

                <VayuBlocksTypography
                    value={attributes.titletypography}
                    onChange={(newValues) => {setAttributes({titletypography:newValues})}}
                />

            </PanelBody>

            <PanelBody 
                title={__('Content', 'vayu-blocks')}
                opened={openPanels['toc-content']}
                onToggle={() => onTogglePanel('toc-content')}
            >

                <VayuBlocksAlignment
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    alignment = {{key:'contentalignment',value:attributes.contentalignment}}
                />

                <VayuBlocksBackground
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    colorPanel = {[
                        {
                            active: ['gradient'],
                            label: 'Background',
                            key:'contentbg',
                            value:attributes.contentbg,
                        },
                        {
                            active: ['color'],
                            label: 'Color',
                            key:'contentcolor',
                            value:attributes.contentcolor,
                        }
                    ]}
                />

                <VayuBlocksDimensions
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    dimensions={{ padding: { key: 'contentPadding', value: attributes.contentPadding }}}
                />

                <br/>
                <VayuBlocksBorder
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    border={{ key: 'contentBorder', value: attributes.contentBorder }}
                    borderRadius={{ key: 'contentBorderRadius', value: attributes.contentBorderRadius }}
                />

                <HeightControl
					label={__('Gap between content list', 'vayu-blocks')}
					value={attributes.contentspacing}
					onChange={(value) => setAttributes({ contentspacing: value })}
                    responsive={true}
                    unitMax={{
						px: { max: 100, step: 1 },
						'%': { max: 10, step: 1 },
						vw: { max: 10, step: 1 },
						vh: { max: 10, step: 1 },
						em: { max: 10, step: 0.1 },
						rem: { max: 10, step: 0.1 },
					}}
				/>

                <br/>

                <VayuBlocksTypography
                    value={attributes.contenttypography}
                    onChange={(newValues) => {setAttributes({contenttypography:newValues})}}
                />

            </PanelBody>

            {attributes. enableCollapse && (
                <PanelBody 
                    title={__('Icon', 'vayu-blocks')}
                    opened={openPanels['toc-icon']}
                    onToggle={() => onTogglePanel('toc-icon')}
                >
                    <HeightControl
                        label={__('Size', 'vayu-blocks')}
                        value={ attributes.iconsize }
                        onChange={ (value) => setAttributes({iconsize: value }) }
                        responsive={true}
                        unitMax={{px: { max: 100, step: 1 },}}
                        customUnits={['px']}
                    />

                    <br/>

                    <VayuBlocksDimensions
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        dimensions={{
                            padding: { key: 'iconPadding', value: attributes.iconPadding },
                        }}
                    />

                    <VayuBlocksBackground
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        colorPanel = {[
                            {
                                active: ['gradient'],
                                label: 'Background',
                                key:'iconbg',
                                value:attributes.iconbg,
                            },
                            {
                                active: ['gradient'],
                                label: 'Hover Background',
                                key:'iconbghvr',
                                value:attributes.iconbghvr,
                            },
                            {
                                active: ['color'],
                                label: 'Color',
                                key:'iconcolor',
                                value:attributes.iconcolor,
                            },
                            {
                                active: ['color'],
                                label: 'Hover Color',
                                key:'iconcolorhvr',
                                value:attributes.iconcolorhvr,
                            },
                            {
                                active: ['color'],
                                label: 'Active Color',
                                key:'iconactivecolor',
                                value:attributes.iconactivecolor,
                            },
                        ]}
                    />

                    <VayuBlocksBorder
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        border={{ key: 'iconBorder', value: attributes.iconBorder }}
                        borderRadius={{ key: 'iconBorderRadius', value: attributes.iconBorderRadius }}
                        dropShadow={{ key: 'iconDropShadow', value: attributes.iconDropShadow }}
                    />

                </PanelBody>
            )}
        </>
    );
};

export default Style;